/* 🤖 this file was generated by script */
export const wiconDocumentDot = {
  name: 'document_dot',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 10.5V3H5v14h3"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M7.03 7.97H13M7 10h2.5M7 5.93h6"/><circle cx="13.5" cy="15.83" r="3.5" fill="#FB8C00"/></svg>`,
};
